import { ModalShell } from '@/components/modals/modal-shell';

export interface GenericErrorPayload {
  status: number;
  message: string;
}

export const GenericErrorModal = ({ payload, onClose }: { payload: GenericErrorPayload; onClose: () => void }) => (
  <ModalShell title='Something went wrong' onClose={onClose}>
    <p>{payload.message}</p>
    <p className='mt-3 text-xs text-neutral-500'>Status: {payload.status}</p>
  </ModalShell>
);
